export const APP_TITLE = import.meta.env.VITE_APP_TITLE;
export const APP_USP = import.meta.env.VITE_APP_USP;

export const MULTIPLE_VALUES_SEPARATOR = ',';

export const MAX_CABLE_POWER_KW = 325;

export const TYPE_DESIGNATION_MODULAR = '';

export const SUPPORT_NAME = 'E-Mobility sales tools';
export const SUPPORT_EMAIL = 'emobilitysalestools@scania.com';

export const MODE = import.meta.env.MODE;

export const MOCKING_ENABLED = import.meta.env.VITE_MOCKING_ENABLED === 'true';

export const SOLUTION_ENDPOINT = import.meta.env.VITE_SOLUTION_ENDPOINT;

export const REVERSE_GEOCODE_ENDPOINT = 'https://revgeocode.search.hereapi.com';

export const MULTIPLE_REVERSE_GEOCODE_ENDPOINT = 'https://multi-revgeocode.search.hereapi.com';

export const AUTOCOMPLETE_ENDPOINT = 'https://autocomplete.search.hereapi.com';

export const LOOKUP_ENDPOINT = 'https://lookup.search.hereapi.com';

export const HERE_MAPS_API_KEY = 'OcOv22pL0eb89DYyu3mAEhRtmzq2RMqAmOLnTWPsEUw';

export const LOCALE_DATE = 'en-GB';

export const APP_IS_UPDATED_STORAGE_KEY = 'appIsUpdated';

// @ts-ignore
export const USER_LANGUAGE = navigator.language || navigator.userLanguage;
